<template>
  <div class="d-print-none">
    <div v-if="!Envio.No == true">
      <b-icon @click="AsignarLugar" class="btn btn-success p-1 mx-1" role="button" icon="arrow-left" font-scale="1.5"></b-icon>
    </div>
    <div v-else>
      <b-icon @click="BajarLugar" v-show="Envio.No < NextOrden - 1" class="btn btn-info p-0 mx-1" role="button" icon="caret-down" font-scale="1.5"></b-icon>
      <b-icon @click="SubirLugar" v-show="Envio.No > 1" class="btn btn-info p-0 mx-1" role="button" icon="caret-up" font-scale="1.5"></b-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: ["Orden", "Envio"],
  computed: {
    NextOrden() {
      let rs = 0;
      let orden = [...this.Orden];

      orden.forEach((v) => {
        if (v.No > rs) rs = v.No;
      });

      rs++;
      return rs;
    },
  },
  methods: {
    BajarLugar() {
      let actual = this.Envio.No;
      let nueva = this.Envio.No + 1;

      this.CambioLugar(actual, nueva);
    },
    SubirLugar() {
      let actual = this.Envio.No;
      let nueva = this.Envio.No - 1;

      this.CambioLugar(actual, nueva);
    },
    CambioLugar(actual, nueva) {
      let orden = [...this.Orden] || [];
      let rs = [];

      orden.forEach((el) => {
        let env = { ...el };
        if (env.No == actual) env.No = nueva;
        else if (env.No == nueva) env.No = actual;
        rs.push(env);
      });

      this.$emit("onUpdateOrden", rs);
    },
    AsignarLugar() {
      let guia = this.Envio.Guia;
      let sig = this.NextOrden;
      let orden = [...this.Orden] || [];
      orden.push({ Guia: guia, No: sig });
      this.$emit("onUpdateOrden", orden);
    },
  },
};
</script>
